import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestPresetsBannerGet = {
    path: "/presets/banner",
    method: RouteHttpVerb.GET
};
export { locationRestPresetsBannerGet };
